import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-date-picker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormGroup } from 'reactstrap';

const DATE_FORMAT = 'MM/dd/yyyy';

const TableFilterDate = ({ filter, onChange }) => (
  <FormGroup className="m-0 custom-filter">
    <DatePicker
      value={filter.value}
      onChange={onChange}
      format={DATE_FORMAT}
      calendarType="US"
      calendarIcon={(<FontAwesomeIcon icon="calendar-alt" />)}
      clearIcon={(<FontAwesomeIcon icon="times" />)}
      className="form-control form-control-sm"
    />
  </FormGroup>
);

TableFilterDate.propTypes = {
  filter: PropTypes.shape(),
  onChange: PropTypes.func.isRequired,
};

TableFilterDate.defaultProps = {
  filter: {},
};

export default TableFilterDate;
